import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Enums from "../../../../../../../utils/Enums";
import MyDetails from "./MyDetails";
import EnroleDependentDetails from "../../../../../../../components/EnroleDependentDetails";
import {getMessageFormat} from '../../../../../../../utils/messageFormatHelper'
import AppBar from "@mui/material/AppBar";

const styles = theme => ({
  root: {
    height: "100%",
    marginLeft: 30,
    marginRight: 30,
    marginTop: 30,
    paddingBottom: 30
  },
  contentInfo: {
    paddingTop: 10,
    paddingBottom: 40,
    background: "#FFFFFF",
    mixBlendMode: "normal",
    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px"
  },
  content: {
    // padding: theme.spacing.unit * 2.5,
    // paddingTop: 10,
    // paddingTop: 10,
    paddingBottom: 40,
    background: "#FFFFFF",
    mixBlendMode: "normal",
    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px"
  },
  header: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      display: "block"
    },
    justifyContent: "space-between"
  },

  tabLabel: {
    fontSize: "18px",
    lineHeight: "40px",
    textAlign: "center"
  },
  tabLabelSelected: {
    fontSize: "18px",
    lineHeight: "40px",
    textAlign: "center",
    color: "#ED1C24"
  },

  info: {
    background: "#F6F6F6",
    borderRadius: "0px 0px 4px 4px",
    padding: "0px 25px 0px 20px",
    fontSize: "16px"
  },
  infoText: {
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    padding: "20px 0px 25px 0px"
  },

  indicator: {
    backgroundColor: "#ED1C24",
    color: "#ED1C24"
  },
  note: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#6B6A6D",
    padding: "15px"
  },
  tabRoot: {
    textTransform: "initial"
  },
  selected: {
    color: "#000000",
    fontSize: 16,
    textAlign: "center",
    background: "white",
    border: "none",
    borderTop: "3px solid #ED1C24",
    fontWeight: 600
  },
  gridStyle1: {
    [theme.breakpoints.down("xs", "sm")]: {
      overflow: "scroll"
    }
  },
  tabsIndicator: {
    background: "#ffffff"
  }
});

class VerifyDetailsMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      content: props.user.content,
      placeholderMap: props.user.placeholderMap,
      plans: {
        selectedTypes: [Enums.PLANS_TYPE.BENEFITS]
      }
    };
  }

  mappingStatus = stages => {
    let getStatus = this.Statuses.filter(status => {
      return status.mapTo.indexOf(stages) > -1;
    });
    return getStatus[0].status;
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.tabValue !== this.props.tabValue) {
      //Perform some operation
      this.setState({
        value: nextProps.tabValue
      });
    }
  }

  render() {
    const { labels } = this.props.user.content;
    const { content, placeholderMap } = this.state;

    const mf = getMessageFormat();
    const note = mf.compile(labels["step1.note"]);
    const placeholderMapTemp = !_.isEmpty(this.props.user.placeholderMap)
      ? new Map(this.props.user.placeholderMap)
      : new Map();
    const { classes, intl } = this.props;
    const styles = {
      avatar: {
        margin: 10
      }
    };
    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.header} />
          <div className={classes.gridStyle1}>
            <AppBar position="static" color="default" elevation={0}>
              <Tabs
                value={this.state.value}
                onChange={this.handleChange}
                scrollable
                scrollButtons="auto"
                classes={{
                  root: classes.tabsRoot,
                  indicator: classes.tabsIndicator
                }}
                // classes={{
                //   indicator: classes.indicator,
                // }}
              >
                <Tab
                  label="Your Details"
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.selected
                  }}
                  style={{ height: "90px" }}
                />
                <Tab
                  label="Dependants Details"
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.selected
                  }}
                  style={{ height: "90px" }}
                />
              </Tabs>
            </AppBar>
            {this.state.value === 0 && (
              <MyDetails history={this.props.history} />
            )}
            {this.state.value === 1 && (
              <EnroleDependentDetails history={this.props.history} />
              // <MyDependantDetails/>
            )}
          </div>
        </div>
        <div className={classes.info}>
          <Typography
            component={"div"}
            className={classes.note}
            dangerouslySetInnerHTML={{
              __html: note({
                supportEmail: placeholderMapTemp.get("{supportEmail}"),
                supportBillingEmail: this.props.user.client_name.config
                  .supportBillingEmail
              })
            }}
          >
            {/* <span dangerouslySetInnerHTML={{__html: note({ supportEmail: placeholderMapTemp.get('{supportEmail}')}) }}> */}
            {/* Note: {this.props.user.content.labels['step1.note']} */}
            {/* In the event of incorrect information, kindly login to <a href={intl.formatMessage({ id: "enrolment.url.myHR" })} target="_blank" style={{color:'#000000',fontWeight:600}}> myHR </a> 
                to update your records before the enrolment period ends on <b>{moment(this.props.user.enrolment_end_date).format("DD MMMM YYYY")}</b>. 
                After the update, a follow-up email will be send to you after 5 working days to continue with the enrolment. */}
            {/* </span> */}
          </Typography>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { user: state.user };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(withStyles(styles, { withTheme: true })(VerifyDetailsMain)));
